

const ProductsIndex = load('products/ProductsIndexComponent')
const ProductsShow = load('products/ProductsShowComponent')
const BagIndex = load('bag/BagIndex')
const Home = load('home/Home')
const Pages = load('pages/Pages')
const NotFound = load('errorPages/NotFound')
const ServerError = load('errorPages/ServerError')
const eGiftCard = load('eGift/eGiftCard')
const ContactUs = load('support/ContactUs')

import store from '../store'
import Router from 'vue-router'
import Checkout from "./checkout";
import Account from "./account";
import SchoolSupplies from './schoolSupplies'
import Subscriptions from './subscription' 
import StoreInformation from './storeInfomation'
import Returns from './returns'
import CatchAll from '../components/errorPages/CatchAll'

import {checkForUtm} from '../mixins/utmHelper'
import { load } from './component-loader'

const initialTitle = " | Eichlers  ";
 
const router = new Router({
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
      
      if (to.hash) {
        return  $('html,body').stop().animate({scrollTop: $(to.hash).offset().top }, 500);
      } 

      if (savedPosition) {
        return new Promise((resolve, reject) => {
          let timeout = to.name == 'SearchIndex' || to.name == 'ProductsIndex' ? 2000 : 500
          
          setTimeout(() => {
            resolve(savedPosition)
          }, timeout)

        })  
      } 
      else {
          return { x: 0, y: 0 }
      }
    },
    routes: [
      ...Checkout,
      ...Account, 
      ...SchoolSupplies,
      ...Subscriptions,
      ...StoreInformation,
      ...Returns,
      {
        path: '/',
        name: 'Home',
        component: Home,
        meta:{title:"Home" + initialTitle}
      },
      {
        path: '/bag',
        name: 'Bag',
        component: BagIndex,
        meta:{title: "Bag" + initialTitle }
      },
      {
        path: '/products/:slug/:id',
        name: 'ProductsShow',
        component: ProductsShow,
        meta:{title:"Eichlers" },
      },
      {
        path: '/bundles/:slug/:id',
        name: 'ProductsShow',
        component: ProductsShow,
        meta:{title:"Eichlers" },
      },  
      {
        path: '/search',
        name: 'SearchIndex',
        component: ProductsIndex,
        meta:{title:"Eichlers"}
      },
      {
        path: '/e-gift-card',
        name: 'eGift',
        component: eGiftCard,
        meta:{title:"eGift Card" + initialTitle }
      },
      {
        path: '/:page/:id',
        name: 'Pages',
        component: Pages,
        meta:{title:"Eichlers"}
      },
      {
        path: '/:index/:slug/:id',
        name: 'ProductsIndex',
        component: ProductsIndex,
        meta:{title:"Eichlers"}
      },  
      {
        path: '/a/:index/:slug/:id',
        name: 'ProductsIndex',
        component: ProductsIndex,
        meta:{title:"Eichlers"}
      },
      {
        path:"/contact-us",
        name:"ContactUs",
        component:ContactUs,
        meta:{title:'Contact us' + initialTitle}
      },
      {
        path:"/500",
        name:"ServerError",
        component:ServerError,
        meta:{title:'Server Error' + initialTitle}
      },
      {
        path:"*",
        name:"404",
        component:NotFound,
        meta:{title:404},
      },
      // {
      //   path:"*",
      //   name:"catchAll",
      //   component:CatchAll
      // }
    ]
  });
  
  export default router;
  
  router.beforeEach((to,from,next)=>{
      next()
      checkForUtm(to.query)
      if(to.path !== from.path){
        document.title = to.meta.title
        store.dispatch('customer/isLogedIn')
        store.dispatch("zipLookUp/requetsZipCode").then(()=>{
          store.dispatch("shippingRates/index")
        }) 
      } 
  })

  router.afterEach(( to, from ) => {

    if(process.env.NODE_ENV == "production"){
      //google analytics
      // if(typeof ga !== 'undefined'){
      //   ga('set', 'page', to.path);
      //   ga('send', 'pageview');
      // }
      
      //facebook
      // if(typeof fbg !== 'undefined'){
      //   fbq('track', 'PageView');
      // }
    }
  });
  


// WEBPACK FOOTER //
// ./resources/js/router/index.js